

import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

// MATERIAL UI
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

const propTypes = {
    loadingInterval: PropTypes.number,
    loadingText: PropTypes.string,
    classes: PropTypes.object.isRequired
};

class Loader extends React.PureComponent {

    render() {

        return <div className={this.props.classes.loader}>
            <Grid container justify='center'>
                <Grid item xs sm={10}>
                    <LinearProgress className={this.props.classes.bar} />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='display1' align='center'>{this.props.loadingText}</Typography>
                </Grid>
            </Grid>
        </div>;
    }
}

Loader.propTypes = propTypes;

const styles = (theme) => ({
    loader: {
        marginTop: theme.spacing.unit * 5,
        textAlign: 'center'
    },
    bar: {
        marginBottom: theme.spacing.unit
    }
});

export default withStyles(styles)(Loader);


// WEBPACK FOOTER //
// ./src/components/loader/index.js